import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'

export default class extends Controller {
  static values = { nextUrl: String }

  connect() {
    this.loading = false
    this.#setupObserver()
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  #setupObserver() {
    if (!('IntersectionObserver' in window)) return
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) this.#loadNextPage()
      })
    }, { rootMargin: '200px 0px' })

    this.observer.observe(this.element)
  }

  #loadNextPage() {
    if (this.loading) return
    if (!this.hasNextUrlValue || !this.nextUrlValue) return

    this.loading = true

    get(this.nextUrlValue, { responseKind: 'turbo-stream' })
  }
}
